import React, { useEffect } from "react";
import styles from "./../crms.module.css";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Table from "../../../component/table";
import swal from "sweetalert";
import { deleteIcon, editIcon, viewIcon } from "../../../../utils/svg.file";
import {
  showContactList,
  deleteContactDetail,
} from "../../../../api/adminPanel/contactUs";
import { useState } from "react";
import DeleteModal from "../../../component/modal/deleteModal";
import {
  deleteAccolades,
  showAccoladesList,
} from "../../../../api/adminPanel/accoladesApi";
export default function ManageAccolades() {
  const navigate = useNavigate();
  const [accoladesList, setAccoladesList] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState("");
  const [deleteId, setDeletedId] = useState("");
  const handleShowDeleteModal = (id) => {
    setDeletedId(id);
    setShowDeleteModal(true);
  };
  const hideDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleDelete = async (id) => {
    const response = await deleteAccolades(id);
    if (response.remote === "success") {
      hideDeleteModal();
      swal("Deleted Successfully!");
      handleShowAccoladesList()
    } else {
    }
  };
  const handleShowAccoladesList = async (id) => {
    const response = await showAccoladesList(id);
    if (response.remote === "success") {
      setAccoladesList(response.data.data);
    } else {
    }
  };
  useEffect(() => {
    handleShowAccoladesList();
  }, []);
  const columns = [
    { field: "id", headerName: "SNo.", width: 100 },
    { field: "category", headerName: "Category", width: 200 },
    { field: "location", headerName: "Location", width: 200 },
    {
      field: "detail",
      width: 500,
      renderCell: (cellValues) => {
        return (
          <>
            <ul className={styles.accolades_details}>
              {/* {cellValues.row.detail} */}
              {cellValues.row.detail.map((item, index) => {
                return (
                  <>
                    <li key={index}>{item.text}</li>
                  </>
                );
              })}
            </ul>
          </>
        );
      },
    },
    {
      field: "Action",
      width: 150,
      renderCell: (cellValues) => {
        return (
          <>
            <span
              className={styles.view_icon_btn}
              onClick={() =>
                navigate(`/view-accolades/${cellValues.row.id}`)
              }
            >
              {viewIcon}
            </span>
            <span
              className={styles.edit_icon_btn}
              onClick={() =>
                navigate(`/edit-accolades/${cellValues.row.id}`)
              }
            >
              {editIcon}
            </span>
            <span
              className={styles.delete_icon_btn}
              onClick={() => {
                handleShowDeleteModal(cellValues.row.id);
              }}
            >
              {deleteIcon}
            </span>
          </>
        );
      },
    },
  ];

  let rows = [];

  accoladesList.map((item, index) => {
    rows.push({
      id: item.id,
      category:
        item.category === "1"
          ? "Restaurants"
          : item.category === "2"
          ? "Hotel & Resorts & Villa"
          : null,
      location: item.location,
      detail: JSON.parse(item.text),
    });
  });

  return (
    <>
      <div className={styles.job_list_page}>
        <div className="">
          <div className={styles.card_body}>
            <div className="d-flex align-items-center justify-content-between mt-2 mb-3">
              <div className={styles.page_title}>
                <h3>Manage Accolades</h3>
              </div>
              <Button
                className={styles.main_button}
                onClick={() => navigate("/add-accolades")}
              >
                Add Accolades
              </Button>
            </div>
            <Table rows={rows} columns={columns} />
          </div>
        </div>
      </div>

      <DeleteModal
        showDeleteModal={showDeleteModal}
        handleDelete={handleDelete}
        hideDeleteModal={hideDeleteModal}
        handleShowDeleteModal={handleShowDeleteModal}
        deleteId={deleteId}
      />
    </>
  );
}
